<template>
  <div>
    <div style="width: 100%; text-align: center">正在授权登录...</div>
  </div>
</template>

<script>
import wechat from "@/api/api-wechat";
import { localToken, cache } from "@/libs/func";
import globConfig from "@/config/config";
import { mapActions } from "vuex";
import common from "@/libs/common";
//授权登录中转页面
export default {
  name: "Oauth",
  data () {
    return {};
  },

  methods: {
    ...mapActions(["handleLogin", "getUserInfo", "getTenantInfo"]),
    //登录成功后跳转到用户即将进入的页面
    toUserRedirect () {
      let that = this;
      //跳转
      let toUrl = localStorage.getItem(globConfig.redirectKey);
      localStorage.removeItem(globConfig.redirectKey);
      if (!toUrl) {
        toUrl = "/";
      }
      console.log(toUrl, "授权登录完成， 跳转");
      that.$router.push(toUrl);
      return true;
    },
    toErrorPage () {
      let that = this;
      common.toJump(that, "/ErrorPage/Error", {
        res: "商户信息获取失败!"
      });
      return true;
    },

    //微信用户信息获取异常的情况
    oauthLoginState (weixinUserInfo) {
      let nowTimes = cache.get(globConfig.oauthExceptionTimesName) || 0;
      nowTimes = parseInt(nowTimes);
      if (nowTimes >= globConfig.oauthExceptionMaxTimes) {
        //清除计次
        cache.set(globConfig.oauthExceptionTimesName, null);
        //返回null 表示超过跳转限制了 需要定向到一个错误页面
        return null;
      }
      //出现微信用户信息获取失败
      //if(typeof weixinUserInfo.nickname === 'undefined' || null === weixinUserInfo.nickname || null === weixinUserInfo.headimgurl) {
      if (
        typeof weixinUserInfo.nickname === "undefined" ||
        null === weixinUserInfo.nickname
      ) {
        cache.set(globConfig.oauthExceptionTimesName, nowTimes + 1);
        return false;
      }
      //清除计次
      cache.set(globConfig.oauthExceptionTimesName, null);
      return true;
    },
    // 记录商户信息
    getTenant (expires) {
      let that = this;
      that.getTenantInfo().then(
        res => {
          localToken.setTenant(JSON.stringify(res), expires);
        },
        err => { }
      );
    }
  },

  created () {
    let that = this;

    //存在token直接跳转
    if (localToken.get()) {
      return that.toUserRedirect();
    }
    let mp = that.$route.query.mp || localToken.getMp();
    if (mp == "" || mp == null) {
      return that.toErrorPage();
    }
    //链接上的code
    let oauthCode = that.$route.query.code || "";

    //console.log(that.$route, oauthCode);
    //如果存在 oauthCode 说明授权已经完成 这里注意 如果code失效的处理
    if (oauthCode) {
      //通过code到api换取用户信息 并且判断用户是否绑定手机号 未绑定手机号用户需要绑定手机号
      //已绑定用户这里应该直接拿到了token 并且保存起来 然后跳转到用户即将跳转到的页面 不存在默认跳首页
      let r = location.href.match(/&state=(.+)(&?)/i);
      let state = r[1];
      // let mp = "test";
      //用户登录
      let params = {
        code: oauthCode,
        mp: mp,
        scope: globConfig.wechatScopInfo,
        state: state
      };

      that.handleLogin(params).then(
        res => {
          //todo 正式
          console.log(res, "login");
          let token = res.token.token_type + " " + res.token.access_token || ""; //token值
          let expires = res.token.expires_in || 7200;

          //这里判断用户微信信息获取情况
          let oauthLoginState = that.oauthLoginState(res.weixinuser);
          if (null === oauthLoginState) {
            //跳转操作限制次数 这里要定向到一个静态的错误页面
            console.log(oauthLoginState, "oauthLoginState 为 null");
            //跳转错误页面 //pass
            common.toJump(that, "/ErrorPage/Error", {
              res: "用户信息获取失败!"
            });
            return false;
          } else if (false === oauthLoginState) {
            console.log(oauthLoginState, "oauthLoginState 为 false");
            //这里刷新本页面
            location.reload();
            return false;
          }
          localToken.setMp(mp, expires);
          localToken.setWeiXinName(res.weixinuser.nickname, expires);
          localToken.setWeiXinImg(res.weixinuser.headimgurl, expires);
          //发送验证码使用(注册token短信验证码和正常业务token不同)
          cache.set(globConfig.anonymousTokenName, token, expires);
          if (res.isMember) {
            localToken.set(token, expires); //存储token（已经登录的token）
            setTimeout(function () {
              that.getTenant(expires);
            }, 100);
            //已注册情况下
            that.toUserRedirect(); //跳转到用户进入页面
          } else {
            //未注册情况下
            //设置注册用token 在ajax调用底层读取
            cache.set(globConfig.registerTokenName, token, expires);
            //设置注册时所需信息，注册方法读取
            cache.set(
              globConfig.registerUserInfo,
              JSON.stringify(res.weixinuser),
              expires
            );
            //跳转注册页面
            that.$router.push("/Register");
          }
        },
        err => { }
      );
    } else {
      //return console.log(that.$route, location.href, 'router');
      //请求生成微信授权链接 然后直接跳转
      //wechat.getOauthUrl(window.location.href).then(res => {
      let params = {
        mp: mp || "f64419fc-5dc7-4cd4-ad7c-aa8b7bafe8bc", //"test",
        //mp: mp || "fe56498e-5b5f-4da2-b855-34804cdf8d5f", //"test",
        version: "v1",
        // redirectUrl: location.href, //todo 正式环境使用
        redirectUrl: location.origin + location.pathname, // 避免重复添加mp
        // redirectUrl: 'https://member.yposdev.azsoft.xin/api/wap/User/login', //测试使用
        scope: globConfig.wechatScopInfo
      };
      //获取微信oauth链接
      //通过接口能获取到一个登录用的token
      //通过微信回调参数code
      //使用登录用token和code 如果用户已注册 能获取到一个用于所有请求的token
      //如果用户未注册  则获取到的token用户注册
      wechat.getOauthUrl(params).then(
        res => {
          //console.log(res);return;
          //存储用于登录的token
          // alert(res.token.access_token)
          let token = res.token.token_type + " " + res.token.access_token;
          let expires = res.token.expires_in;
          cache.set(globConfig.loginTokenName, token, expires); //设置登录用token 在ajax调用底层读取
          //todo 跳转到微信oauth链接(正式环境使用)
          location.href = res.url;

          //测试环境跳转(使用方法)
          //注释掉上面的 location.href = xxx
          //浏览器的控制台查看获取到的 url
          //通过电脑版微信 访问url 会得到一串东西 复制value内的内容到 api-wechat.js 内 loginTest方法(参考已有数据)
          //然后放开location.href = xxx的注释
          //会跳到注册界面 直接进行注册
          // let r = res.url.match(/&state=(.+?)&/i);
          // let state = r[1];
          // location.href = location.href + '?code=' + '12345&state=' + state;
          console.log(res, "oauth链接");
        },
        err => {
          console.log(err);
          //换取链接失败
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/Oauth.vue